<!--
  SceneCreationAlert.svelte

  Displays a success alert when a scene has been created,
  or a "Scene Created" chip when the scene is pending upload.
-->
<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert, Chip } from '@Shelly/shelly-design-system';

	export let sceneCreated: boolean;
	export let sceneId: string | undefined;
	export let onOpenScene: (sceneId: string | undefined) => void;
</script>

{#if sceneCreated && sceneId}
	<div class="mt-xs">
		<Alert
			type="success"
			heading="Scene created successfully!"
			isHeadingBold={true}
			cta={{
				title: $format('button_open_scene', { default: 'Open Scene' }),
				enableAlertClick: true,
			}}
			on:cta_click={() => onOpenScene(sceneId)}
		/>
	</div>
{:else if sceneCreated}
	<!-- Scene created but not yet uploaded (no sceneId yet) -->
	<div class="message-badge mt-xs">
		<Chip variant="success" icon="fas fa-check-circle" aria-label="Scene Created">
			Scene Created
		</Chip>
	</div>
{/if}

<style>
	.message-badge {
		display: flex;
		flex-wrap: wrap;
		gap: 4px;
	}
</style>
